import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 5rem)',
    backgroundColor: '#f7f7f7',
    fontFamily: theme.typography.fontFamily,
    padding: '32px 24px 64px',
    ['@media (max-width: 900px)']: {
      padding: '20px 16px 48px',
    },
  },
  content: {
    maxWidth: 720,
    margin: '0 auto',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.primary.main,
    margin: '0 0 8px',
  },
  subtitle: {
    fontSize: 14,
    color: '#6b6b6b',
    margin: '0 0 24px',
    lineHeight: 1.5,
  },
  card: {
    padding: 24,
    borderRadius: 12,
    marginBottom: 16,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
    marginBottom: 12,
  },
  planName: {
    fontSize: 20,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: 0,
  },
  planDescription: {
    fontSize: 14,
    color: '#6b6b6b',
    lineHeight: 1.5,
    margin: '8px 0 0',
  },
  price: {
    fontSize: 18,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: '16px 0 0',
  },
  meta: {
    fontSize: 14,
    color: '#6b6b6b',
    margin: '8px 0 0',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 20,
    paddingTop: 16,
    borderTop: '1px solid #eeeeee',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    fontSize: 14,
  },
  detailLabel: {
    color: '#8a8a8a',
  },
  detailValue: {
    color: '#1a1a1a',
    fontWeight: 600,
    textAlign: 'right',
  },
  statusChip: {
    color: '#ffffff',
    fontWeight: 600,
    height: 28,
  },
  actions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    marginTop: 20,
  },
  primaryButton: {
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  emptyCard: {
    padding: 32,
    borderRadius: 12,
    textAlign: 'center',
  },
  emptyText: {
    fontSize: 15,
    color: '#6b6b6b',
    margin: '0 0 20px',
    lineHeight: 1.5,
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    padding: '8px 24px 24px',
  },
  modalBody: {
    padding: '24px',
    fontSize: 14,
    color: '#4a4a4a',
    lineHeight: 1.5,
  },
}));
